import React from "react";
import Link from "next/link";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarGroupLabelIcon,
  useSidebar,
} from "@src/lib/ui/Sidebar";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@src/lib/ui/Collapsible";
import UsersOutlineIcon from "@src/lib/icons/18px/users-outline";
import UsersSettingsOutlineIcon from "@src/lib/icons/18px/users-settings-outline";
import { useRouter } from "next/router";
import { useBooleanLocalStorage } from "@src/lib/hooks/useLocalStorage";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";

import AdminLeftNavLocationsMenuButton from "@src/features/app/left-nav/admin/AdminLeftNavLocationsMenuButton";
import AdminLeftNavRolesMenuButton from "@src/features/app/left-nav/admin/AdminLeftNavRolesMenuButton";

const AdminLeftNavPeopleMenu: React.FC = () => {
  const { state } = useSidebar();
  const { pathname } = useRouter();
  const { userActionPermissions } = useActionPermissions();
  const [isOpen, setIsOpen] = useBooleanLocalStorage(
    `admin-left-nav-people-menu-open`,
    true,
  );
  return (
    <Collapsible
      asChild
      open={state === "collapsed" ? true : isOpen}
      onOpenChange={setIsOpen}
      className="group/collapsible"
    >
      <SidebarGroup>
        <SidebarGroupLabel asChild>
          <CollapsibleTrigger>
            People
            <SidebarGroupLabelIcon />
          </CollapsibleTrigger>
        </SidebarGroupLabel>
        <CollapsibleContent>
          <SidebarGroupContent>
            <SidebarMenu>
              <AdminLeftNavLocationsMenuButton />
              <AdminLeftNavRolesMenuButton />
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  tooltip="Users"
                  isActive={pathname === "/users"}
                >
                  <Link href="/users">
                    <UsersOutlineIcon />
                    Users
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              {userActionPermissions?.manageOrgIntegrations ? (
                <SidebarMenuItem className="mt-4">
                  <SidebarMenuButton
                    asChild
                    tooltip="HRIS"
                    isActive={pathname.startsWith("/settings/hris")}
                  >
                    <Link href="/settings/hris">
                      <UsersSettingsOutlineIcon />
                      HRIS
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ) : null}
            </SidebarMenu>
          </SidebarGroupContent>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  );
};

export default AdminLeftNavPeopleMenu;
